import { render, staticRenderFns } from "./CrudRepositionOrders.vue?vue&type=template&id=33169c1b&scoped=true&"
import script from "./CrudRepositionOrders.vue?vue&type=script&lang=js&"
export * from "./CrudRepositionOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33169c1b",
  null
  
)

export default component.exports